import React, { useEffect } from "react";
import BackButton from "../components/BackButton";

const s = {
  wrapper: { minHeight: "100svh", background: "#f3f4f6", padding: "16px 16px 40px", boxSizing: "border-box", fontFamily: "system-ui, -apple-system, sans-serif" },
  inner: { maxWidth: "680px", margin: "0 auto" },
  card: { background: "white", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", border: "1px solid #f1f5f9", padding: "24px 20px" },
  h1: { fontSize: "22px", fontWeight: 800, color: "#1e293b", margin: "0 0 4px" },
  tagline: { fontSize: "13px", color: "#64748b", fontStyle: "italic", margin: "0 0 20px" },
  h2: { fontSize: "14px", fontWeight: 700, color: "#1e293b", marginTop: "20px", marginBottom: "6px" },
  p: { fontSize: "14px", color: "#475569", lineHeight: 1.7, margin: "0 0 4px" },
  ul: { fontSize: "14px", color: "#475569", lineHeight: 1.7, paddingLeft: "20px", margin: "4px 0 4px" },
  a: { color: "#2563eb" },
};

const PrivacyPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={s.wrapper}>
      <div style={s.inner}>
        <BackButton fallback="/" />
        <div style={s.card}>
          <h1 style={s.h1}>🔐 Politique de Confidentialité – CrushNow®</h1>
          <p style={s.tagline}>
            Dernière mise à jour : mai 2026<br />
            Marque déposée INPI n° <strong>5152773</strong>
          </p>

          <h2 style={s.h2}>1. Responsable du traitement</h2>
          <p style={s.p}><strong>Lia Balagna-Ranin</strong> — Éditeur de l'application — 5 square du Midi, 95000 Cergy, France — SIRET : en cours d'immatriculation — Contact : <a href="mailto:support@crush-now.fr" style={s.a}>support@crush-now.fr</a></p>

          <h2 style={s.h2}>2. Données collectées</h2>
          <p style={s.p}><strong>Tous les utilisateurs :</strong></p>
          <ul style={s.ul}>
            <li>Pseudonyme ou email selon le mode d'inscription choisi</li>
            <li>Mot de passe (hashé, jamais stocké en clair)</li>
            <li>Historique de scans (codes-barres, noms produits, horodatage)</li>
            <li>Prix observé d'un produit (uniquement si saisi volontairement par l'utilisateur)</li>
            <li>Coordonnées GPS au moment du scan (uniquement si géolocalisation activée)</li>
            <li>Identifiant du magasin le plus proche au moment du scan (store_id) — uniquement si géolocalisation activée, dans un rayon de 500m</li>
            <li>Ville et nom du commerce au moment du scan (uniquement si géolocalisation activée, via reverse geocoding)</li>
            <li>Token de notification FCM (uniquement si notifications activées)</li>
            <li>Données de navigation stockées en localStorage : session utilisateur, préférences (géolocalisation, notifications)</li>
            <li>Données démographiques optionnelles (genre, tranche d'âge) — uniquement si renseignées volontairement dans le profil</li>
            <li>URL de partage de crush (/c/:slug) générée lors du partage d'un produit — publique et accessible sans compte</li>
            <li>Compteur de partages par produit — anonyme, non lié à l'identité</li>
            <li>Liste des magasins favoris (store_id et nom) — stockée en base, liée au compte</li>
          </ul>
          <p style={s.p}><strong>Accès matériel :</strong></p>
          <ul style={s.ul}>
            <li>Caméra : utilisée pour scanner les codes-barres et, si vous le choisissez, prendre une photo d'un produit lors d'un ajout communautaire. Les photos de produits sont stockées uniquement si vous les soumettez volontairement. Aucune image n'est transmise à un tiers.</li>
          </ul>
          <p style={s.p}><strong>Produits communautaires (ajout manuel) :</strong></p>
          <ul style={s.ul}>
            <li>Photo du produit (optionnelle, uniquement si soumise volontairement, stockée en base de données)</li>
            <li>Note libre associée au produit (optionnelle)</li>
            <li>Nom du magasin saisi manuellement (optionnel)</li>
          </ul>
          <p style={s.p}><strong>Vendeurs uniquement :</strong></p>
          <ul style={s.ul}>
            <li>Numéro SIRET (vérifié via API INSEE)</li>
            <li>Adresse et coordonnées GPS du magasin</li>
            <li>Statistiques agrégées de scans dans leur zone</li>
          </ul>
          <p style={s.p}><strong>Mode sans email :</strong></p>
          <ul style={s.ul}>
            <li>Phrase de récupération de 12 mots (hashée, jamais stockée en clair, affichée une seule fois)</li>
          </ul>
          <p style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", padding: "10px 14px", color: "#166534", fontSize: "12px", lineHeight: 1.6, marginTop: "10px" }}>
            <strong>Important :</strong> Les gérants de magasins inscrits sur CrushNow® accèdent uniquement à des statistiques anonymisées sur leur propre point de vente (ex : "47 scans ce mois"). Ils ne voient jamais votre nom, votre email, votre pseudonyme ou votre historique personnel.
          </p>

          <h2 style={s.h2}>3. Finalités des traitements</h2>
          <ul style={s.ul}>
            <li>Fonctionnement du compte utilisateur</li>
            <li>Affichage et enrichissement de l'historique de scans</li>
            <li>Scan de codes-barres et, optionnellement, prise de photo de produit via caméra lors d'un ajout communautaire</li>
            <li>Association du scan au magasin le plus proche (rayon 500m) pour cibler les notifications produit — optionnel, uniquement si géolocalisation activée</li>
            <li>Suggestion de prix d'un produit à partir de données open source (Open Prices)</li>
            <li>Envoi d'alertes push (si consentement)</li>
            <li>Statistiques anonymisées pour les vendeurs inscrits</li>
            <li>Vérification de l'identité des vendeurs</li>
            <li>Personnalisation des notifications selon les magasins favoris sélectionnés par l'utilisateur</li>
            <li>Partage public d'un produit via URL unique (/c/:slug)</li>
            <li>Collecte optionnelle de données démographiques pour des statistiques anonymisées vendeur</li>
          </ul>

          <h2 style={s.h2}>4. Base légale</h2>
          <ul style={s.ul}>
            <li><strong>Consentement</strong> : géolocalisation, notifications push</li>
            <li><strong>Exécution du contrat</strong> : fonctionnalités du compte, historique</li>
            <li><strong>Intérêt légitime</strong> : sécurité, lutte contre la fraude vendeur</li>
          </ul>

          <h2 style={s.h2}>5. Durée de conservation</h2>
          <ul style={s.ul}>
            <li>Comptes inactifs depuis plus de <strong>24 mois</strong> : suppression automatique (compte + scans + tokens)</li>
            <li>Historique de scans : <strong>12 mois glissants</strong> (purge automatique quotidienne)</li>
            <li>Tokens FCM : supprimés à la désactivation des notifications ou lors de la purge quotidienne si invalides</li>
            <li>SIRET vendeur : conservé tant que le compte vendeur est actif</li>
            <li>Journaux d'audit RGPD (logs de consentement et suppressions) : <strong>36 mois</strong></li>
          </ul>

          <h2 style={s.h2}>6. Services tiers et transferts hors UE</h2>
          <p style={s.p}>CrushNow® utilise les services suivants susceptibles de traiter vos données :</p>
          <ul style={s.ul}>
            <li>
              <strong>Railway (USA)</strong> — hébergement backend et base de données —
              certifié EU-US Data Privacy Framework ✅ —
              DPA accepté automatiquement par l'utilisation du service
              (conformément aux conditions Railway) —
              version signée disponible sur demande à privacy@railway.com
            </li>
            <li>
              <strong>Firebase / Google (USA)</strong> — notifications push (FCM) —
              certifié EU-US Data Privacy Framework ✅ —
              DPA Google standard applicable
            </li>
            <li>
              <strong>MongoDB Atlas</strong> — base de données —
              DPA MongoDB applicable — région de stockage : Europe (Paris, eu-west-3) ✅
            </li>
            <li>
              <strong>Google Maps Platform / Google Places (USA)</strong> — recherche et résolution du nom du commerce à partir des coordonnées GPS ou d'une requête textuelle —
              certifié EU-US Data Privacy Framework ✅ —
              DPA Google standard applicable —
              seules les coordonnées GPS anonymes et/ou la requête de recherche sont transmises, sans identifiant utilisateur,
              données non conservées par Google au-delà de la requête
            </li>
            <li>
              <strong>OpenStreetMap / Nominatim (Allemagne)</strong> — deux usages distincts :
              (1) reverse geocoding : coordonnées GPS anonymes transmises pour déterminer la ville au moment du scan ;
              (2) géocodage d'adresse : l'adresse postale du magasin vendeur est transmise lors de l'enregistrement de l'adresse du point de vente, afin d'obtenir ses coordonnées GPS —
              service européen, hébergé en Allemagne ✅ —
              aucune donnée personnelle conservée au-delà de la requête
            </li>
            <li>
              <strong>Open Food Facts (France)</strong> — enrichissement du catalogue produits à partir du code-barres (EAN) : nom du produit, catégorie, image —
              service open source français hébergé en Europe ✅ —
              seul le code-barres du produit est transmis, aucune donnée personnelle n'est envoyée
            </li>
            <li>
              <strong>Open Prices (France)</strong> — consultation du prix moyen d'un produit à partir de son code-barres (EAN) —
              service open source hébergé en Europe ✅ —
              seul le code-barres du produit est transmis, aucune donnée personnelle n'est envoyée
            </li>
            <li>
              <strong>EAN-Search (Allemagne)</strong> — enrichissement du catalogue produits à partir du code-barres (EAN) : nom et catégorie du produit —
              service hébergé en Allemagne ✅ —
              seul le code-barres du produit est transmis, aucune donnée personnelle n'est envoyée
            </li>
            <li>
              <strong>UPCitemdb (USA)</strong> — enrichissement du catalogue produits à partir du code-barres (EAN) : nom, catégorie, image —
              encadré par les conditions d'utilisation UPCitemdb —
              seul le code-barres du produit est transmis, aucune donnée personnelle n'est envoyée
            </li>
            <li>
              <strong>Brevo (France)</strong> — envoi d'emails transactionnels —
              hébergé en France et en Europe ✅ —
              conforme RGPD nativement — DPA Brevo applicable
            </li>
            <li>
              <strong>INSEE / Sirene (France)</strong> — vérification SIRET vendeur —
              service public français — aucun transfert hors UE
            </li>
          </ul>
          <p style={{ fontSize: "12px", color: "#64748b", lineHeight: 1.6, marginTop: "10px" }}>
            Conformément à l'article 28 du RGPD, CrushNow® s'assure que tous ses sous-traitants
            présentent des garanties suffisantes pour la protection des données personnelles.
            Les transferts hors UE sont encadrés soit par une décision d'adéquation
            (EU-US Data Privacy Framework), soit par des Clauses Contractuelles Types (CCT)
            approuvées par la Commission Européenne.
          </p>

          <h2 style={s.h2}>7. Vos droits (RGPD)</h2>
          <p style={s.p}>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul style={s.ul}>
            <li><strong>Accès</strong> : obtenir une copie de vos données</li>
            <li><strong>Rectification</strong> : corriger des données inexactes</li>
            <li><strong>Effacement</strong> : supprimer votre compte et toutes vos données via le bouton "Supprimer mon compte" dans votre profil, ou par email à support@crush-now.fr</li>
            <li><strong>Portabilité</strong> : recevoir vos données dans un format structuré</li>
            <li><strong>Opposition</strong> : vous opposer à certains traitements</li>
            <li><strong>Retrait du consentement</strong> : désactiver la géolocalisation ou les notifications à tout moment depuis votre profil</li>
          </ul>
          <p style={s.p}>Pour exercer vos droits : <strong>support@crush-now.fr</strong></p>
          <p style={s.p}>Vous pouvez également introduire une réclamation auprès de la <strong>CNIL</strong> : <a href="https://www.cnil.fr" style={s.a} target="_blank" rel="noopener noreferrer">www.cnil.fr</a></p>

          <h2 style={s.h2}>8. Sécurité</h2>
          <ul style={s.ul}>
            <li>Mots de passe hashés avec bcrypt</li>
            <li>Phrases de récupération hashées avec bcrypt, jamais stockées en clair</li>
            <li>Communications chiffrées via HTTPS</li>
            <li>Clés d'API stockées en variables d'environnement, jamais dans le code</li>
            <li>Données non revendues, non partagées avec des tiers non autorisés</li>
          </ul>

          <h2 style={s.h2}>9. Cookies et stockage local</h2>
          <p style={s.p}>CrushNow® n'utilise pas de cookies publicitaires. Les données suivantes sont stockées dans votre navigateur (localStorage) :</p>
          <ul style={s.ul}>
            <li>Session utilisateur (token d'authentification)</li>
            <li>Préférences : géolocalisation activée/désactivée, notifications</li>
            <li>Token FCM (si notifications activées)</li>
          </ul>
          <p style={s.p}>Ces données restent sur votre appareil et sont supprimées à la déconnexion ou à la suppression du compte.</p>

          <h2 style={s.h2}>10. Rapports d'erreurs techniques</h2>
          <p style={s.p}>Pour améliorer la stabilité de l'application, CrushNow propose un système de rapport d'erreurs volontaire.</p>
          <p style={s.p}>Lorsqu'une erreur technique survient, les informations suivantes sont enregistrées temporairement sur votre appareil uniquement :</p>
          <ul style={s.ul}>
            <li>Type et contexte de l'erreur</li>
            <li>Adresse de la page concernée</li>
            <li>Modèle de navigateur ou d'appareil (User-Agent)</li>
            <li>Horodatage</li>
          </ul>
          <p style={s.p}>Ces données ne sont transmises à nos serveurs que si vous appuyez explicitement sur <strong>« Signaler un problème »</strong> dans votre profil. Aucun envoi automatique n'a lieu.</p>
          <p style={s.p}>Les rapports reçus sont conservés <strong>90 jours</strong> puis supprimés automatiquement. Ils sont utilisés uniquement à des fins de débogage et ne sont jamais partagés avec des tiers.</p>
          <p style={s.p}>Le rapport peut également inclure votre journal de navigation de la session en cours (pages visitées et actions effectuées, horodatées). Ce journal n'est jamais transmis automatiquement et est effacé de votre appareil après envoi ou à la fermeture de l'application.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
